import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_147: FaireProductEntity = {
  token: "legacy_prod_abbott-147",
  type: "product",
  name: "Candy Jar with Lid-8 H",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/4d8ec1446343bae92aede7b91e16c1062b6b7b1c3554123edf9898b0e8b798d7.jpeg",
  priceDollars: 22,
  subcategory: "Serveware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
